// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2fvE8","productName":"Table_productName__3hNct"};